/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentStatus } from './DocumentStatus';
import {
    DocumentStatusFromJSON,
    DocumentStatusFromJSONTyped,
    DocumentStatusToJSON,
    DocumentStatusToJSONTyped,
} from './DocumentStatus';
import type { UploadTarget } from './UploadTarget';
import {
    UploadTargetFromJSON,
    UploadTargetFromJSONTyped,
    UploadTargetToJSON,
    UploadTargetToJSONTyped,
} from './UploadTarget';

/**
 * 
 * @export
 * @interface UploadBatchDocument
 */
export interface UploadBatchDocument {
    /**
     * 
     */
    document_id: string;
    /**
     * 
     */
    client_request_id: string;
    /**
     * 
     */
    status: DocumentStatus;
    /**
     * 
     */
    targets: Array<UploadTarget>;
}



/**
 * Check if a given object implements the UploadBatchDocument interface.
 */
export function instanceOfUploadBatchDocument(value: object): value is UploadBatchDocument {
    if (!('document_id' in value) || value['document_id'] === undefined) return false;
    if (!('client_request_id' in value) || value['client_request_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('targets' in value) || value['targets'] === undefined) return false;
    return true;
}

export function UploadBatchDocumentFromJSON(json: any): UploadBatchDocument {
    return UploadBatchDocumentFromJSONTyped(json, false);
}

export function UploadBatchDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadBatchDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'document_id': json['document_id'],
        'client_request_id': json['client_request_id'],
        'status': DocumentStatusFromJSON(json['status']),
        'targets': ((json['targets'] as Array<any>).map(UploadTargetFromJSON)),
    };
}

export function UploadBatchDocumentToJSON(json: any): UploadBatchDocument {
    return UploadBatchDocumentToJSONTyped(json, false);
}

export function UploadBatchDocumentToJSONTyped(value?: UploadBatchDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'document_id': value['document_id'],
        'client_request_id': value['client_request_id'],
        'status': DocumentStatusToJSON(value['status']),
        'targets': ((value['targets'] as Array<any>).map(UploadTargetToJSON)),
    };
}

